import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_M_BP,
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	DESKTOP_SM_BP,
	COLOR_WHITE,
	COLOR_DARK_GREEN_BUTTON,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	display: flex;
	flex-flow: wrap;
	justify-content: center;
	align-items: center;
	padding: 60px 20px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 35px 5px;
	}
	@media only screen and (max-width: ${TABLET_BP}px) {
		padding: 35px 30px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 35px 20px;
	}
`;

export const VideoCarousal = styled.div`
	width: 50%;

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		width: 80%;
		padding: 5px 0px;

		.slick-dots {
			margin-bottom: 10px;
		}
	}

	.mentor-info {
		text-align: center;
		font-size: 16px;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		margin-top: 12px;
		font-weight: ${FONT_WT_MEDIUM};
	}

	.slick-dots li {
		margin: 0px;
	}

	.slick-dots {
		margin-top: 15px;
		bottom: -40px;
	}
	.slick-dots li.slick-active button:before {
		color: ${COLOR_DARK_GREEN_BUTTON};
	}
	.slick-dots li button:before {
		height: 15px;
		width: 15px;
		font-size: 15px;
		color: ${COLOR_DARK_GREEN_BUTTON};
	}

	.slick-arrow {
		display: none !important;
	}
`;

export const VideoContainer = styled.div`
	background: ${COLOR_WHITE};
	width: 700px;
	box-shadow: 0px 9px 30px #d6e8e3;

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		width: 60%;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 90%;
	}
`;

export const Heading = styled.div`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: ${(props) => props.fontSize};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-right: 100px;
	margin-bottom: 15px;
	width: 352px;

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		text-align: center;
		margin-right: 0px;
		width: 100%;
		font-size: 30px;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 28px;
	}
`;

export const Description = styled.div`
	width: 400px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	line-height: 1.5;

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		text-align: center;
		width: unset;
	}
`;

export const Content = styled.div`
	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		margin-bottom: 40px;
	}
`;
